// 3rd party imports
import * as React from 'react';
import { Redirect, Route } from 'react-router';
import { inject, observer } from 'mobx-react';

// mobx
import { UserAuthStore } from 'stores';
import { AuthState } from 'sources';

// components
import { RenderWrapper } from './render-wrapper';

interface ProgramRelationshipAuthorizedRouteProps {
  path: string;
  redirectPath: string;
  component: any;
  render?: any;
  requireAuthorization: boolean;
  userAuth?: UserAuthStore;
}

@inject('userAuth')
@observer
export class SecureRoute extends React.Component<ProgramRelationshipAuthorizedRouteProps> {
  constructor(props) {
    super(props);
    this.createRenderWrapper = this.createRenderWrapper.bind(this);
  }

  // RenderWrapper has the authenticated (i.e. am I logged in) check
  // I don't know why we can't do that check in this component
  public createRenderWrapper() {
    return <RenderWrapper component={this.props.component} render={this.props.render} />;
  }

  private renderAuthenticated() {
    // If we have a crashed session, this will give a blank page. :-/
    if (this.props.userAuth.authenticated === AuthState.UNKNOWN) {
      return null;
    }

    return <Route path={this.props.path} render={this.createRenderWrapper} />;
  }

  private renderAuthorized() {
    if (
      this.props.userAuth.authenticated === AuthState.UNKNOWN ||
      this.props.userAuth.authorized === AuthState.UNKNOWN
    ) {
      return null;
    }

    if (this.props.userAuth.authenticated === AuthState.TRUE && this.props.userAuth.authorized === AuthState.TRUE) {
      return <Route path={this.props.path} render={this.createRenderWrapper} />;
    }

    return <Redirect to={this.props.redirectPath} />;
  }

  public render() {
    if (!this.props.requireAuthorization) {
      return this.renderAuthenticated();
    }

    return this.renderAuthorized();
  }
}
